import { useState, useCallback } from "react"

export function useViewPreference(key: string, defaultView: string): [string, (view: string) => void] {
  const storageKey = `okeycrm-${key}-view`

  const [view, setViewState] = useState<string>(() => {
    try {
      return localStorage.getItem(storageKey) || defaultView
    } catch {
      return defaultView
    }
  })

  const setView = useCallback(
    (newView: string) => {
      setViewState(newView)
      try {
        localStorage.setItem(storageKey, newView)
      } catch {
        // localStorage unavailable
      }
    },
    [storageKey],
  )

  return [view, setView]
}
